<template>
  <div>
    <!-- 所有一览按钮 -->
    <el-button type="primary" class="btn-default my-button" size="small" :disabled="isDisabled" @click="onClick">
      <slot></slot>
    </el-button>
  </div>
</template>
<script>
export default {
  props:{
    disabledParam: Boolean
  },
  data(){
    return{
      isDisabled: this.disabledParam
    }
  },
  watch:{
    disabledParam:function(value){
      this.isDisabled = value
    }
  },
  methods: {
    onClick(event) {
      if (this.$listeners.click) {
        this.$listeners.click()
        event.stopPropagation();
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.my-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  color:#525250;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  padding: 10px 20px;
  font-size: 13px;
  border-radius: 8px;
  width: 146px;
  height: 40px;
  background-color: #F2F2ED;
  border: 0;
  box-shadow: -2px -2px 4px #fff,
              4px 4px 4px #E6E6E1;
  &:focus,
  &:hover {
    border-radius: 8px;
    transition: all .3s;
    background-color: rgba(0, 0, 0, 0.04);
    color: rgba(82, 82, 80, 0.6);
  }
  &.is-disabled {
      color: #B8B8B4;
      background-color: #F2F2ED;
  }
  &.is-plain:hover {
    background: #fff;
    border-color: #409eff;
    color: #409eff;
    &.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
      background-image: none;
      background-color: #fff;
      border-color: #ebeef5;
    }
  }
  & + .my-button {
    margin-left: 20px;
  }
}
</style>
